import styled from "styled-components";
import { IconDefinition } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { StickerContainer } from "@components/Sticker";

export const IconButtonContainer = styled(StickerContainer)`
  display: flex;
  cursor: pointer;
  flex-direction: row;
  align-items: center;
  gap: var(--global-spacing-m);
  margin: 8px;
  &:hover {
    color: #ffffff;
    background-color: var(--global-purple);
  }
`;

interface IconButtonProps {
  title: React.ReactNode;
  icon: IconDefinition;
  onClick: React.MouseEventHandler;
}

export const IconButton = ({ title, icon, onClick }: IconButtonProps) => (
  <IconButtonContainer onClick={onClick}>
    <FontAwesomeIcon
      icon={icon}
      style={{ fontSize: "var(--global-font-size-xl)" }}
    />
    <div
      style={{
        fontSize: "var(--global-font-size-m)",
        float: "right",
        width: "300px",
      }}
    >
      {title}
    </div>
  </IconButtonContainer>
);
